import DataAccess from './constants';
import API from './API'

const path = 'TourHolds'
let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const postTourHold = (tourhold) => {
    return api.postData(path, tourhold);
}

// export const deleteTourHold = (params) => {
//     return api.getData(path + params);
// }

//Remove, as we are not using it anymore.